import { render, staticRenderFns } from "./purchaseCheques.vue?vue&type=template&id=163eaedf"
import script from "./purchaseCheques.vue?vue&type=script&lang=js"
export * from "./purchaseCheques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports